import { render, staticRenderFns } from "./roominfo.vue?vue&type=template&id=c89b6dfc&scoped=true"
import script from "./roominfo.vue?vue&type=script&lang=js"
export * from "./roominfo.vue?vue&type=script&lang=js"
import style0 from "./roominfo.vue?vue&type=style&index=0&id=c89b6dfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b6dfc",
  null
  
)

export default component.exports